<template>
  <div class="archived-tasks">
    <div class="archived-tasks__header flex align-center justify-between">
      <h2 class="archived-tasks__title">Архів завдань</h2>
      <SmartLink :method="() => $emit('change-view-mode', 'active-tasks')" class="tasks-active">Активні завдання</SmartLink>
    </div>
    <TasksListSkeleton :is-loading="!isArchivedTasksDataReady" :items-count="7">
      <TasksList
        v-if="!isEmpty"
        class="archived-tasks__list"
        :current-page="getCurrentPage"
        :page-size="getPerPageCount"
        :total-tasks="getArchivedTasksTotalCount"
        :tasks="getArchivedTasksList"
        @page-changed="handlePageChanged"
        @task-clicked="handleShowInfoPopup"
      />
      <EmptyBlock
        v-else
        :title="getEmptyMessage.title"
        :description="getEmptyMessage.description"
        height="350px"
      />
    </TasksListSkeleton>

    <TaskInfoPopup
      ref="taskInfoPopup"
      task-type="archived"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import TaskInfoPopup from '../task-info-popup';
import TasksList from '../tasks-list';
import TasksListSkeleton from '../tasks-list-skeleton';
import { archivedTasksEmptyMessages } from '@/features/tasks';
import { EmptyBlock } from '@/shared/ui/empty-block';
import { SmartLink } from '@/shared/ui/link';

export default {
  data() {
    return {
      selectedTask: { id: '', name: '', description: '', finishDate: '' },
      currentPage: 1,
    };
  },
  created() {
    this.setupFilter({ period: { end: moment().subtract(1, 'days').toDate(), } }, 'update', false);
    this.fetchArchivedTasksList();
  },
  components: { TasksList, SmartLink, TasksListSkeleton, EmptyBlock, TaskInfoPopup },
  computed: {
    ...mapGetters('archivedTasksModule', [
      'getArchivedTasksList', 'getCurrentPage', 'getPerPageCount', 'getArchivedTasksTotalCount', 'isArchivedTasksDataReady',
      'isEmpty',
    ]),
    getEmptyMessage() { return archivedTasksEmptyMessages[0]; },
  },
  methods: {
    ...mapActions('archivedTasksModule', ['fetchArchivedTasksList', 'setupFilter', 'changePaginatedPage']),
    handlePageChanged(page) {
      this.changePaginatedPage(page);
    },
    handleShowInfoPopup(task) {
      this.$refs.taskInfoPopup.open(task);
    },
  },
};
</script>

<style lang="scss" scoped>
.archived-tasks {
  display: flex;
  flex-direction: column;
  border: 1px solid #E4E4E7;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;
  height: 100%;

  &__header {
    margin-bottom: 24px;
  }

  &__title {
    font-family: inherit;
    font-size: 20px;
    font-weight: 600;
  }

  &__list {
    margin-bottom: 24px;
  }
}

.tasks-active {
  color: #858C95;
  font-weight: 500;
  line-height: 15px;
  border-bottom: 1px solid #858C95;

  &:hover {
    border-bottom: 1px solid transparent;
  }
}
</style>
